//Sidebar imports
import DashboardIcon from '@mui/icons-material/Dashboard';
import DataThresholdingIcon from '@mui/icons-material/DataThresholding';

//Sidebar data
export const SidebarData = [
    {
        icon: DashboardIcon,
        heading: "Dashboard",
        route: "/dashboard",
        iconAlt: DashboardIcon
    },
    // {
    //     icon: DataThresholdingIcon,
    //     heading: "Emociones",
    //     route: "/emociones",
    // }
]